import { render, staticRenderFns } from "./UserContacts.vue?vue&type=template&id=0f11b077&scoped=true&"
import script from "./UserContacts.vue?vue&type=script&lang=js&"
export * from "./UserContacts.vue?vue&type=script&lang=js&"
import style0 from "./UserContacts.vue?vue&type=style&index=0&id=0f11b077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11b077",
  null
  
)

export default component.exports